export const byPosition = (a, b)=>{
    var _ref, _ref1;
    const aPosition = (_ref = a === null || a === void 0 ? void 0 : a.position) !== null && _ref !== void 0 ? _ref : -2;
    const bPosition = (_ref1 = b === null || b === void 0 ? void 0 : b.position) !== null && _ref1 !== void 0 ? _ref1 : -2;
    if (aPosition === bPosition) {
        return 0;
    }
    return aPosition > bPosition ? 1 : -1;
};
